import { StaticIcon } from 'components/common/StaticIcon'
import useTranslation from 'next-translate/useTranslation'
import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react'

type Props = {
  hasFollowed?: boolean
} & DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

export const SaveButton = ({ hasFollowed, ...props }: Props) => {
  const { t } = useTranslation('common')

  return (
    <button
      {...props}
      type='button'
      className='absolute right-0 top-4 z-[1] flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-purple-50/50 outline-none sm:-right-2 lg:right-16 lg:h-12 lg:w-12'
    >
      <span className='sr-only'>
        {hasFollowed ? t('unsave_artwork') : t('save_artwork')}
      </span>

      <StaticIcon
        name={hasFollowed ? 'filledHeart' : 'heart'}
        className='text-primary-default'
        size={20}
      />
    </button>
  )
}
